import React from "react";
import { Wallets } from "./AboutView";

export const Support = () => {
    return (
        <div className="support">
            <span>Thank you for playing!</span>
            <span className="support-text">Enjoyed your time here? Support the game’s future with <a href="https://www.patreon.com/cw/PlayArkhamHorrorOnline">my Patreon</a> or crypto:</span>
            <Wallets />
        </div>
    )
}
